<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script setup lang="ts">
import SvgIcon from "../SvgIcon.vue";

const props = defineProps({
  modelValue: { type: null },
  placeHolder: { type: String },
  fitArea: { type: Boolean, default: true },
  error: { type: Boolean, default: false },
  stretch: { type: Boolean, default: true },
});
const emit = defineEmits(["update:modelValue"]);
const areaInput = ref<HTMLTextAreaElement | null>(null);

function areaInputValueChange($event: any) {
  if (props.fitArea) fitAreaToText();
  emit("update:modelValue", $event.target.value);
}

function fitAreaToText() {
  if (areaInput.value) {
    areaInput.value.style.height = "auto";
    areaInput.value.style.height = areaInput.value.scrollHeight + "px";
  }
}

onMounted(() => {
  if (props.fitArea) fitAreaToText();
});

watch(
  () => props.modelValue,
  () => {
    if (props.fitArea) nextTick(fitAreaToText);
  },
);
</script>

<template>
  <div class="wrap">
    <SvgIcon
      v-if="props.stretch"
      class="pull-tab cursor-pointer w-[16px] h-[16px] text-secondary-color"
      name="etirable"
    ></SvgIcon>
    <textarea
      ref="areaInput"
      :value="modelValue"
      :placeholder="placeHolder"
      v-bind="$attrs"
      :class="{ 'error-border ': error }"
      @input="areaInputValueChange"
    ></textarea>
  </div>
</template>

<style lang="scss">
textarea {
  @apply relative z-[1];
}

.wrap {
  @apply flex relative w-full;
}

.wrap:after {
  @apply absolute z-[1] opacity-50 right-0 bottom-0 pointer-events-none;
  content: "";
}

.pull-tab {
  @apply absolute z-[2] bottom-[3px] right-[3px] pointer-events-none;
}

::-webkit-resizer {
  @apply hidden;
}

.error-border {
  border-color: var(--red-main) !important;
  &:hover,
  &:focus,
  &:active {
    @apply cursor-pointer;
    border-color: var(--red-main);
  }
}
</style>
